import { render, staticRenderFns } from "./sourceManagement.vue?vue&type=template&id=6f6aea5a&scoped=true"
import script from "./sourceManagement.vue?vue&type=script&lang=js"
export * from "./sourceManagement.vue?vue&type=script&lang=js"
import style0 from "./sourceManagement.vue?vue&type=style&index=0&id=6f6aea5a&prod&scoped=true&lang=css"
import style1 from "./sourceManagement.vue?vue&type=style&index=1&id=6f6aea5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6aea5a",
  null
  
)

export default component.exports